/**
 * Panneau : mes ingrédients (saisie, astuce, quick start, courants, sélectionnés)
 */

import React from "react";
import { motion } from "framer-motion";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";
import IngredientInputWithSuggestions from "./IngredientInputWithSuggestions.jsx";
import QuickStartSection from "./QuickStartSection.jsx";
import CommonIngredientsSection from "./CommonIngredientsSection.jsx";
import SelectedIngredientsSection from "./SelectedIngredientsSection.jsx";

export default function IngredientsPanel({
  currentIngredient,
  setCurrentIngredient,
  showIngredientSuggestions,
  setShowIngredientSuggestions,
  ingredientSuggestionsList,
  handleIngredientInputFocus,
  handleIngredientInputBlur,
  applyIngredientSuggestion,
  addIngredient,
  availableIngredients,
  setAvailableIngredients,
  removeIngredient,
  getIngredientLabel,
  t,
}) {
  return (
    <motion.div
      className={`${glassPanel} p-4 sm:p-6 rounded-2xl sm:rounded-3xl mb-6`}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.05 }}
    >
      <h2 className="text-lg font-semibold text-ink-900 dark:text-white mb-4 flex items-center gap-2">
        <HiOutlineMagnifyingGlass className="w-5 h-5 text-orange-300" />
        {t("myAvailableIngredients")}
      </h2>

      <IngredientInputWithSuggestions
        currentIngredient={currentIngredient}
        setCurrentIngredient={setCurrentIngredient}
        showIngredientSuggestions={showIngredientSuggestions}
        setShowIngredientSuggestions={setShowIngredientSuggestions}
        ingredientSuggestionsList={ingredientSuggestionsList}
        handleIngredientInputFocus={handleIngredientInputFocus}
        handleIngredientInputBlur={handleIngredientInputBlur}
        applyIngredientSuggestion={applyIngredientSuggestion}
        addIngredient={addIngredient}
        getIngredientLabel={getIngredientLabel}
        t={t}
      />

      <p className="text-xs text-ink-500 dark:text-white/70 mb-4 flex items-center gap-1.5">
        <span className="text-orange-300">●</span>
        {t("translationTip")}
        {t("translationExample") && (
          <span className="text-ink-400 dark:text-white/50"> — {t("translationExample")}</span>
        )}
      </p>

      <QuickStartSection
        addIngredient={addIngredient}
        getIngredientLabel={getIngredientLabel}
        t={t}
      />
      <CommonIngredientsSection
        availableIngredients={availableIngredients}
        addIngredient={addIngredient}
        getIngredientLabel={getIngredientLabel}
        t={t}
      />
      <SelectedIngredientsSection
        availableIngredients={availableIngredients}
        setAvailableIngredients={setAvailableIngredients}
        removeIngredient={removeIngredient}
        getIngredientLabel={getIngredientLabel}
        t={t}
      />
    </motion.div>
  );
}
